import React, {useContext, useState, useEffect, useRef} from "react";
import {useLocation, useHistory} from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {AuthContext} from "../../../contexts/auth/auth.context";
import Table from 'react-bootstrap/Table';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/Replay';
import {Link} from "react-router-dom";
import {ToggleButton} from "react-bootstrap";
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import * as Constant from "../../../constants/Constant";
import {OverlayTrigger, Popover, Toast, Spinner, Modal} from "react-bootstrap"
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import API from "../../../network/dashboardAPI";
import {
	getProduct,
	searchProduct,
	getBrands,
	getCategory,
	getSubCategory,
	getSuppliers,
	getSubCategoryMap,
	uploadPromotion,
	getCountries
} from '../../../store/actions/dashboardAction'
import {connect} from "react-redux";
import moment from "moment";
import {FormattedNumber} from 'react-intl';
import {read, utils} from 'xlsx';
import xlsx from 'json-as-xlsx';
import FlagIconFactory from 'react-flag-icon-css';
import PIcon from '../../../assets/images/delishop-favicons.png'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import Checkbox from '@material-ui/core/Checkbox';
import {FormControlLabel, FormLabel, Switch, Typography} from "@material-ui/core";
import Select from 'react-select';
import './react-select.css';
import {FaFilter} from "react-icons/fa";
import {CgPlayListRemove} from "react-icons/cg";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import {makeStyles} from '@material-ui/core/styles';
import SelectAndSearchComponent from "../../../components/SelectAndSearchComponent/SelectAndSearchComponent";

const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(3),
	},
	button: {
		margin: theme.spacing(1, 1, 0, 0),
	},
}));
const FlagIcon = FlagIconFactory(React, {useCssModules: false});
const Heading = styled.h3`
    font-size: 21px;
    font-weight: 700;
    color: #0d1136;
    line-height: 1.2;
    margin-bottom: 25px;
    width: 100%;
    text-align: center;
`;

const HelpPageWrapper = styled.div`
    background-color: #fff;
    padding: 30px 20px;
    margin-top: 15px;
    border-radius: 10px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    position: relative;
    /* padding: 50px 0 50px 0; */
    min-height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    table tr th {
        position: sticky;
        top: 0;
        border: 1px solid #dee2e6;
        background-color: #f9f9f9;
    }

    @media (max-width: 989px) {
        padding-top: 70px;
    }

    .image_load {
        position: absolute;
        background-color: rgb(255, 255, 255, 0.4);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .sort-style {
        cursor: pointer;
    }
`;


const TableBodyWidth = styled.div`
    table tr th {
        white-space: nowrap;
        width: initial;
        scrollbar-width: none;
    }

    ::-webkit-scrollbar {
        display: none;
    }
`;

const ProductListing = (props) => {
	const classes = useStyles();
	const {authDispatch} = useContext(AuthContext);
	let admin = localStorage.getItem("admin");
	let parsedUser = JSON.parse(admin);
	if (!admin) {
		window.location.href = "/";
	}
	const location = useLocation();
	const history = useHistory();
	const params = new URLSearchParams(location.search);
	const searchTerm = params.get("sku");
	let productListUrl = Constant.baseUrl + "api/admin/products";
	let productSearchUrl = Constant.baseUrl + "api/admin/products/search";
	let productEnableDisableUrl = Constant.baseUrl + "api/admin/product/enable";
	let productQuantityUpdateUrl = Constant.baseUrl + "api/admin/product/changeQuantity";
	const [productsUrl, setProductsUrl] = useState(productListUrl);
	const [progress, setProgress] = useState(0);
	const [brand, setBrand] = useState(0);
	const [cat, setCat] = useState(16);
	const [oos, setOos] = useState(0);
	const [page, setPage] = useState(1);
	const [totalPage, setTotalPage] = useState(0);
	const [totalItems, setTotalItems] = useState(0);
	const [previous, setPrevious] = useState(false);
	const [next, setNext] = useState(false);
	const [showEnable, setShowEnable] = useState(false);
	const [showDisable, setShowDisable] = useState(false);
	const [modalHead, setModalHead] = useState("");
	const [modalMessage, setModalMessage] = useState("");
	const [editId, setEditId] = useState(null);
	const [searchString, setSearchString] = useState(searchTerm || "");
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [isError, setIsError] = useState(false);
	const [errorText, setErrorText] = useState("");
	const [available, setAvailable] = useState(0);
	const [products, setProducts] = useState({
		loading: false,
		data: null,
		error: false
	});
	const [showInStock, setShowInStock] = useState(false);
	const [showOutOfStock, setShowOutOfStock] = useState(false);
	const [modalHeadQuantityModal, setModalHeadQuantityModal] = useState("");
	const [modalMessageQuantityModal, setModalMessageQuantityModal] = useState("");
	const [quantity, setQuantity] = useState(0);
	const [quantityError, setQuantityError] = useState(false);

	const [showToast, setShowToast] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [deleteItemName, setDeleteItemName] = useState('');
	const [toastBgColor, setToastBgColor] = useState('bg-success');
	const [toastMessage, setToastMessage] = useState("Delete successful");
	const [editedItem, setEditedItem] = useState({});
	const [dialogDelete, setDialogDelete] = useState(false);

	const enableButtonRef = useRef(null);
	const disableButtonRef = useRef(null);
	const markOutOfStockButtonRef = useRef(null);
	const quantityInputRef = useRef(null);

	const [showImage, setShowImage] = useState(false);
	const [imgUrl, setImgUrl] = useState("")
	const [flag, setflag] = useState(true)
	const [filters, setFilters] = useState(null);
	// Sort
	const [orderField, setOrderField] = useState("item_id");
	const [orderType, setOrderType] = useState("DESC");
	const UpArrow = "↑";
	const DownArrow = "↓";
	const UpDownArrow = "↑↓";
	const orderTypeOpts = ["DESC", "ASC"];
	const [itemCountry, setItemCountry] = useState(0);
	const [itemOrderStatus, setItemOrderStatus] = useState('all');
	const [itemOOS, setItemOOS] = useState("all");
	/**
	 * =============== handle_sort_orders =================
	 */

	/**
	 *
	 * @param {*} event handle change status
	 */
	const handleStatusChange = (event) => {
		setItemOrderStatus(event.target.value);
	};

	/**
	 *
	 * @param {*} event handle change oos item
	 */

	const handleOOSChange = (event) => {
		setItemOOS(event.target.value);
	};

	//--------- handle sort --------------//
	const handleSortOrder = (field) => {
		if (field === orderField) {
			setOrderType(orderTypeOpts.find(x => x !== orderType));
		} else {
			setOrderType("ASC");
			setOrderField(field);
		}
	};

	/**
	 * =========== clear_filters =========
	 */
	const handleClearFilter = async () => {
		setOrderType("DESC");
		setOrderField("item_id");
		setFilters(null);
		setShowFilterModal(false);
		setItemCat(0);
		setItemSubCat(0);
		setItemBrand(0);
		setItemSupplierId(0);
		setItemNewArrival(null);
		setItemTrending(null);
		setItemPromoTion(null);
		setItemCountry(0)
		setItemDietary([])
		setItemOrderStatus("all")
		setItemOOS("all")
		await applyFilter("clear");
	}
	let countriesOptions = null;

	//** get country option filter **//
	useEffect(() => {
		props.getCountries({})
	}, [])
	if (props.countries) {
		countriesOptions = props.countries;
	}
	const changeCountry = ((event) => {
		setItemCountry(event)
	})

	// ===================== end ======================//
	const hnadleShowImageClose = () => {
		setShowImage(false)
	}
	const hnadleShowImageOpen = (url) => {
		setImgUrl(url)
		setShowImage(true)
	}


	const addProductPage = (event) => {
		window.location.href = "/admin/product/add";
	}

	const getProductsListPrevious = (event) => {
		if (page > 1) {
			//  searchProducts(productsUrl,page-1);
			//setPage(page-1)
			if (flag) getProducts(page - 1)
			else searchInitiate(productSearchUrl, page - 1)
		} else {
			alert("No record on previous page")
		}
	};

	const getProductsListFirst = (event) => {
		if (page > 1) {
			if (flag) getProducts(1)
			else searchInitiate(productSearchUrl, 1)
		} else {
			// alert("No record on previous page")
		}
	};

	const getProductsListLast = (event) => {
		if (next) {
			if (flag) getProducts(totalPage)
			else searchInitiate(productSearchUrl, totalPage)
		} else {
			alert("No record on next page")
		}
	};

	const getProductsListNext = (event) => {
		if (next) {
			// searchProducts(productsUrl,page+1);
			//    setPage(page+1)
			if (flag) getProducts(page + 1)
			else searchInitiate(productSearchUrl, page + 1)
		} else {
			alert("No record on next page")
		}
	};
	const handleSetQuantity = (event) => {
		setQuantity(event.target.value)
	}

	const enableModal = (proId, proName) => {
		setEditId(proId);
		setAvailable(1);
		setModalHead("Enable");
		setModalMessage("Want to enable product - '" + proName + "'?");
		setShowEnable(true);
		//console.log("here"+proId+proName)
	};

	const disableModal = (proId, proName) => {
		setEditId(proId);
		setAvailable(0);
		setModalHead("Disable");
		setModalMessage("Want to disable product - '" + proName + "' ?");
		setShowDisable(true);
		// console.log("here"+proId+proName)
	};

	const handleClose = () => {
		setShowEnable(false);
		setShowDisable(false);
	}

	const rowEvent = {
		onClick: (row) => {
			//  console.log(row)
		}
	}

	const enableProduct = () => {
		setModalHead("Updating");
		API.updatenableDisableProduct({
			item_id: editId,
			is_available: available,
		})
			.then(response => {
				setShowEnable(false);
				setShowDisable(false);
				//  console.log("falg-1", flag)
				if (flag) getProducts(page) ///
				else searchInitiate(productSearchUrl, page)
			}).catch((error) => {
			setModalHead(error.response.data);
		});
	};

	const handleCloseQuantityModal = () => {
		setShowInStock(false);
		setShowOutOfStock(false);
	}
	const inStockQuantityModal = (proId, proName) => {
		setQuantityError(false)
		setEditId(proId);
		// setAvailable(1);
		setQuantity(0)
		setModalHeadQuantityModal("In Stock");
		setModalMessageQuantityModal("Want to make in stock product - '" + proName + "'?");
		setShowInStock(true);
		// console.log("here"+proId+proName)
	};

	const outOfStockQuantityModal = (proId, proName) => {
		setEditId(proId);
		//setAvailable(0);
		setQuantity(0);

		setModalHeadQuantityModal("Out Of Stock");
		setModalMessageQuantityModal("Want to make Out Of Stock product - '" + proName + "' ?");
		setShowOutOfStock(true);
		//  console.log("here"+proId+proName)
	};


	const [showDeletedProductModal, setShowDeletedProductModal] = useState(false);
	const [productsIsDeleted, setProductsIsDeleted] = useState(1);
	const [dPage, setDPage] = useState(1);
	const [tPage, setTPage] = useState(0);
	const [prev, setPrev] = useState(false);
	const [nextPage, setNextPage] = useState(false);
	const [confirmReverseModal, setConfirmReverseModal] = useState(false);
	const [searchStr, setSearchStr] = useState('');
	const [reversedItemId, setReversedItemId] = useState(null);
	const [productsDeletedUrl, setProductsDeletedUrl] = useState(productListUrl)
	const [ifDeleteOrReverse, setIfDeleteOrReverse] = useState(false)
	const [dFlag, setDFlag] = useState(true);
	// const [deletedProductsUrl, setDeletedProductsUrl] = useState(productListUrl)

	const [getIsDeletedProduct, setGetIsDeletedProduct] = useState({
		loading: false,
		data: [],
		error: false
	});
	//handle show deleted product modal
	const handleShowDeleteProductModal = () => {
		setShowDeletedProductModal(true);
		setProductsIsDeleted(1);
		setDPage(1)
		setTPage(1);
		setSearchStr('')
		let idDeletedProduct = {};
		idDeletedProduct.idDeleted = productsIsDeleted;
		// setGetIsDeletedProduct(idDeletedProduct)
	}
	const handleCloseDeleteProductModal = () => {
		setShowDeletedProductModal(false);
		// setProductsIsDeleted(0)
		setFilters(null)
		setSearchString('');
		setSearchStr('');
		getProducts(page)
	}

	const getDeletedProductsListPrevious = (event) => {
		if (dPage > 1) {
			if (dFlag) getProductsDeleted(dPage - 1)
			else searchDeletedInitiate(dPage - 1)
		} else {
			alert("No record on previous page")
		}
	};

	const getDeletedProductsListNext = (event) => {
		if (nextPage) {
			// searchProducts(productsUrl,page+1);
			//    setPage(page+1)
			if (dFlag) getProductsDeleted(dPage + 1)
			else searchDeletedInitiate(dPage + 1)
		} else {
			alert("No record on next page")
		}
	};

	//search deleted function

	const searchDStr = (e) => {
		setSearchStr(e.target.value);
	}
	const searchDeletedInitiate = (pageNumber) => {
		// if(searchString.length > 2) {
		setDFlag(false)
		// setProductsDeletedUrl(productsDeletedUrl);
		searchDeletedProducts(pageNumber);
	};

	//search deleted function
	const searchDeletedProducts = (pageNumber) => {
		let postData = {
			search: searchStr,
			page: pageNumber,
			isDeleted: productsIsDeleted,
			limit: 20
		};
		API.searchProductNew(postData)
			.then((response) => response.json())
			.then(response => {
				if (response.data && response.data.list.length == 20) {
					setNextPage(true)
				} else {
					setNextPage(false);
				}
				setGetIsDeletedProduct({
					loading: false,
					data: response.data.list,
					error: false
				})
				setDPage(pageNumber);
				setTotalItems(response.data.total_count);
				setTPage(response.data.total_page);
				// setIsError(false);
				// setIsSubmitted(false);
			}).catch((error) => {
			setGetIsDeletedProduct({
				loading: false,
				data: [],
				error: error
			})
			// setIsError(true);
			// setErrorText(error.response.data);
			// setIsSubmitted(false);
		});
	};

	const getProductsDeleted = (pageNumber) => {
		setDFlag(true)
		API.getProduct({
			page: pageNumber,
			limit: 20,
			filter: null,
			search: searchStr,
			isDeleted: productsIsDeleted
		})
			.then((response) => response.json())
			.then(response => {
				setGetIsDeletedProduct({
					loading: false,
					data: response.data.list,
					error: false
				})
				// setProductsDeletedUrl(productListUrl);
				setDPage(pageNumber);
				setTPage(response.data.total_page);

				if (response.data.list.length == 20) {
					setNextPage(true)
				} else {
					setNextPage(false);
				}
			}).catch((error) => {
			setGetIsDeletedProduct({
				loading: false,
				data: [],
				error: true
			})
		});
	}

	const ReversedProduct = async (product) => {
		try {
			setShowToast(false);
			await API.reversedProduct({item_id: product.item_id})
				.then((response) => response.json())
				.then(response => {
					if (response.success === true) {
						setConfirmReverseModal(false);
						setShowToast(true);
						getProductsDeleted(dPage)
						setToastMessage('Product has Reverse Successfully')
					}
				})
		} catch (error) {
			setShowToast(true);
			setToastBgColor('bg-danger');
			setToastMessage('Product has Reverse fail')
			console.log(error);
		}
	};

	const showReversedModal = (data) => {
		setConfirmReverseModal(!confirmReverseModal);
		setReversedItemId(data)
	}

	const handleConfirmReverse = () => {
		ReversedProduct(reversedItemId)
	}


	useEffect(() => {
		setGetIsDeletedProduct({
			loading: true,
			data: [],
			error: false
		})
		setDFlag(true)
		if (showDeletedProductModal === true) {
			getProductsDeleted(dPage)
		}
	}, [showDeletedProductModal]);


	const inStockProduct = (e) => {
		e.preventDefault();

		if (modalHeadQuantityModal === "In Stock") {
			if (quantity > 0) {
				setQuantityError(false)
				setModalHeadQuantityModal("Updating");
				API.quantityUpdateProduct({
					item_id: editId,
					quantity: quantity,
				})
					.then(response => {
						setShowInStock(false);
						setShowOutOfStock(false);
						//   console.log("falg-2", flag)

						if (flag) getProducts(page) ///
						else searchInitiate(productSearchUrl, page)
					}).catch((error) => {
					console.log(error)
					//setModalHeadQuantityModal(error);
				});
			} else {
				setQuantityError(true)
			}

		} else {
			setModalHeadQuantityModal("Updating");
			API.quantityUpdateProduct({
				item_id: editId,
				quantity: quantity,
			})
				.then(response => {
					setShowInStock(false);
					setShowOutOfStock(false);
					// console.log("falg-3", flag)

					if (flag) getProducts(page) ///
					else searchInitiate(productSearchUrl, page)
				}).catch((error) => {

				//setModalHeadQuantityModal(error);
			});
		}

	};

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			searchInitiate(productSearchUrl, 1)
		}
	}

	const searchInitiate = (strUrl, pageNumber) => {
		// if(searchString.length > 2) {
		setflag(false)
		setProductsUrl(productSearchUrl);
		if (searchTerm) {
			params.delete("sku");

			history.replace({
				pathname: location.pathname,
				search: params.toString(),
			});
		}
		searchProducts(strUrl, pageNumber);
		// } else {
		//     setIsError(true);
		//     setErrorText("Write at least 3 characters to search");
		//     setIsSubmitted(false);
		// }
	};

	const searchProducts = (urlString, pageNumber) => {
		let supplier = 0;
		if (itemSupplierId != 0) supplier = itemSupplierId?.store_user_id || 0;
		let postData = {
			search: searchString,
			page: pageNumber,
			filter: filters,
			supplier: supplier,
			limit: 20
		};
		API.searchProductNew(postData)
			.then((response) => response.json())
			.then(response => {
				if (response.data && response.data.list.length == 20) {
					setNext(true)
				} else {
					setNext(false);
				}
				setProducts({
					loading: false,
					data: response.data.list,
					error: false
				})
				setPage(pageNumber);
				setTotalPage(response.data.total_page);
				setTotalItems(response.data.total_count);
				setIsError(false);
				setIsSubmitted(false);
			}).catch((error) => {
			setProducts({
				loading: false,
				data: null,
				error: false
			})
			setIsError(true);
			setErrorText(error.response?.data);
			setIsSubmitted(false);
		});
	};

	const getProducts = (pageNumber) => {
		setflag(true)
		let supplier = 0;
		//  console.log("falg get", flag)
		if (itemSupplierId != 0) supplier = itemSupplierId?.store_user_id || 0;
		API.getProduct({
			page: pageNumber,
			limit: 20,
			search: searchString || "",
			filter: filters,
			supplier: supplier,
			orderField,
			orderType
		})
			.then((response) => response.json())
			.then(response => {
				setProducts({
					loading: false,
					data: response.data.list,
					error: false
				})
				setProductsUrl(productListUrl);
				setPage(pageNumber);
				setTotalItems(response.data.total_count);
				setTotalPage(response.data.total_page);

				if (response.data.list.length == 20) {
					setNext(true)
				} else {
					setNext(false);
				}
			}).catch((error) => {

			setProducts({
				loading: false,
				data: null,
				error: true
			})
		});
	}

	const getPromotionDateDisplay = (product) => {
		return product.promo ? `${moment(product.promo_start_date).format("DD/MM/YY")} - ${moment(product.promo_end_date).format("DD/MM/YY")}` : "";
	}

	// get product with filter
	useEffect(() => {
		setIfDeleteOrReverse(false)
		setflag(true)
		setProducts({
			loading: true,
			data: null,
			error: false
		})
		getProducts(page)
	}, [productListUrl, ifDeleteOrReverse, orderField, orderType]);

	useEffect(() => {
		setIfDeleteOrReverse(false)
		setflag(true)
		// ----------------------------------- for filter ------------------
		props.getCategory({
			store_id: 1,
			get_type: 1
		})
		props.getBrands({});
		props.getSuppliers({})
		fetchDietaryPreferences();
		// ------------------------ filter-------------------------
	}, [productListUrl, ifDeleteOrReverse]);

	// Fetch dietary preferences
	const fetchDietaryPreferences = async () => {
		try {
			const response = await API.getDietaryPreferencesList({is_available: 1, is_deleted: 0});
			const data = await response.json();
			if (data && data.data) {
				setDietaryPreferences(data.data);
			}
		} catch (error) {
			console.error('Error fetching dietary preferences:', error);
		}
	};

	const changeSearchString = ((event) => {
		setSearchString(event.target.value)
	});
	const logoWrapper = {
		display: "flex",
		alignItems: "fill"
	}
	const logo = {
		height: "50Px",
		width: "50Px",
		objectFit: "contain"
	}
	let content = null;
	let message = null;
	if (products.error) {
		message =
			<tr>
				<td>Some error in response.</td>
			</tr>;
	}
	if (products.loading) {
		message =
			<tr>
				<td className="image_load">
					<Spinner animation="border" variant="success"/>
				</td>
			</tr>
	}

	const softDeleteProduct = async () => {
		const item_id = editedItem.item_id;
		const itemRow = document.getElementById(`item-row-${item_id}`);

		setIsLoading(true);
		setShowToast(false);

		setTimeout(() => {
			document.body.click();
			setIsLoading(false);
			setShowToast(true);
			itemRow.remove();
		}, 750);
		try {
			await API.deleteProduct({item_id})
				.then((response) => response.json())
				.then(response => {
					setTimeout(() => {
						document.body.click();
						setIsLoading(false);
						setShowToast(true);
						itemRow.remove();
					}, 750)
				})
			setIfDeleteOrReverse(true)
			setDialogDelete(false);
		} catch (error) {
			console.log(error);
			setDialogDelete(false);
		}
	};
	const handleDialogDelete = (status = false, data = null) => {
		if (data !== null) {
			setEditedItem(data);
			setDeleteItemName(data.name);
		} else {
			setDeleteItemName('');
		}

		setDialogDelete(status);

		if (!status)
			setEditedItem({});
	};

	function isExpired(start, end) {
		start = new Date(start).getTime()
		const now = new Date().getTime()
		end = new Date(end).getTime()
		return !(end >= now)

	}

	if (products.data) {
		// console.log(!isExpired(product.promo_cost_start_date,product.promo_cost_end_date))

		content =
			products.data.map((product, key) =>
				<tr id={`item-row-` + product.item_id} key={key}>
					<td onClick={() => hnadleShowImageOpen(product.default_image_url)} style={logoWrapper}><img
						src={!product.default_image_url ? PIcon : product.default_image_url} alt="img" style={logo}
						onError={(e) => {
							e.target.onerror = null;
							e.target.src = PIcon;
						}}/></td>
					<td>{product ? product.item_id : ""}</td>
					<td>{product ? product.product_code : ""}</td>
					<td>{product ? product.name : ""}</td>
					<td>{product.list_brands[0] ? product.list_brands[0].name : ""}</td>
					<td>{product.store_items_price_types[0] ? product.store_items_price_types[0].available_quantity : 0}</td>
					<td>{product.store_items_price_types[0] ? product.store_items_price_types[0].name : ""}</td>
					<td>
						{product.map_products_supplier_products && product.map_products_supplier_products.length > 0 ? (
							<div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
								{(() => {
									// Get unique suppliers by supplier_id
									const uniqueSuppliers = [];
									const seenIds = new Set();

									product.map_products_supplier_products.forEach((mapping) => {
										const supplierId = mapping.supplier_product?.supplier_id;
										const supplierName = mapping.supplier_product?.supplier?.first_name || '';

										if (supplierId && !seenIds.has(supplierId)) {
											seenIds.add(supplierId);
											uniqueSuppliers.push({
												id: supplierId,
												name: supplierName
											});
										}
									});

									return uniqueSuppliers.map((supplier, idx) => (
										<div key={supplier.id} style={{padding: '2px 0'}}>
											- {supplier.name || `Supplier ${supplier.id}`}
										</div>
									));
								})()}
							</div>
						) : '-'}
					</td>
					<td>{product.list_categories[0] ? product.list_categories[0].name : ""}</td>
					<td>{product.list_sub_categories[0] ? product.list_sub_categories[0].name : ""}</td>
					<td>{product.countries[0] ?
						<div style={{display: 'flex', alignItems: 'flex-start', gap: '0.25em'}}><span><FlagIcon
							code={product.countries[0].code.toLowerCase()}/></span>{product.countries[0].name}</div> : "-"}</td>
					<td>
						{product.store_item_dietary_preferences && product.store_item_dietary_preferences.length > 0 ? (
							<div style={{display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center'}}>
								{product.store_item_dietary_preferences.map((dp, idx) => (
									dp.dietary_preference && (
										<OverlayTrigger
											key={idx}
											placement="top"
											overlay={
												<Popover id={`dietary-${product.item_id}-${idx}`}>
													<Popover.Content>{dp.dietary_preference.name}</Popover.Content>
												</Popover>
											}
										>
											<img
												src={dp.dietary_preference.image_url}
												alt={dp.dietary_preference.name}
												style={{width: '20px', height: '20px', objectFit: 'contain', cursor: 'pointer'}}
											/>
										</OverlayTrigger>
									)
								))}
							</div>
						) : "-"}
					</td>
					<td>{product.store_items_price_types?.[0]?.unit_cost != null ?
						<FormattedNumber value={product.store_items_price_types[0].unit_cost} style="currency" currency="USD"/> : "-"}</td>
					<td>{product.store_items_price_types[0] ?
						<FormattedNumber value={product.store_items_price_types[0].price} style="currency"
						                 currency="USD"/> : ""}</td>
					<td> {(product.promo_cost != null && product.promo_cost != 0) && !isExpired(product.promo_cost_start_date, product.promo_cost_end_date) ?
						<FormattedNumber value={product.promo_cost} style="currency" currency="USD" maximumFractionDigits={4}/> : "-"}
					</td>
					<td>{product.promo ?
						<FormattedNumber value={product.promo_price}
						                 style="currency"
						                 currency="USD"
						/> : "-"}</td>
					<td>{product.promo ? getPromotionDateDisplay(product) : "-"}</td>
					<td>{product.order}</td>
					{/* <td>{product.trending === 0? "N/A": "Yes"}</td> */}
					<td>{product.store_items_price_types[0].is_available == 1 ?
						(
							<Button variant="success" onClick={() => disableModal(product.item_id, product.name)}>
								Enabled
							</Button>
						) : (
							<Button variant="danger" onClick={() => enableModal(product.item_id, product.name)}>
								Disabled
							</Button>
						)}</td>
					{/* <td>{product.store_items_price_types[0].available_quantity == 0 ?
						(
							<Button variant="danger" onClick={() => inStockQuantityModal(product.item_id, product.name)}>
								Out of Stock
							</Button>
						) : (
							<Button variant="success" onClick={() => outOfStockQuantityModal(product.item_id, product.name)}>
								In Stock
							</Button>
						)}
					</td> */}
					<td width="120">
						<div className="d-flex flex-row" style={{height: '100%'}}>
							<Link target="_blank"
							      to={{pathname: '/admin/product/update?item_id=' + product.item_id, state: {id: product.item_id}}}>
								<Button variant="info" type="submit" style={{height: '100%'}}>
									<EditIcon></EditIcon>
								</Button>
							</Link>
							<Button className="ml-1" variant="danger" onClick={() => handleDialogDelete(true, product)}><DeleteIcon/></Button>
						</div>
					</td>
				</tr>
			)
	}
	//------------------ for filter
	const [showFilterModel, setShowFilterModal] = useState(false);
	const [itemCat, setItemCat] = useState(0);
	const [itemSubCat, setItemSubCat] = useState(0);
	const [itemBrand, setItemBrand] = useState(0);
	const [itemSupplierId, setItemSupplierId] = useState(0);
	const [itemNewArrival, setItemNewArrival] = useState(null);
	const [itemTrending, setItemTrending] = useState(null);
	const [itemPromotion, setItemPromoTion] = useState(null);
	const [itemDietary, setItemDietary] = useState([]);
	const [dietaryPreferences, setDietaryPreferences] = useState([]);

	/**
	 *
	 * @param {*} event handle change item promotion
	 */
	const handleItemPromotionChange = (event) => {
		if (!event.target.checked) {
			setItemPromoTion(0);
		} else {
			setItemPromoTion(1);
		}
	}

	const handleItemTrendingChange = (event) => {
		if (!event.target.checked) {
			setItemTrending(0);
		} else {
			setItemTrending(1);
		}
	}

	/**
	 *
	 * @param {*} event handle change new arrival
	 */
	const handleItemNewArrivalChange = (event) => {
		if (!event.target.checked) {
			setItemNewArrival(0);
		} else {
			setItemNewArrival(1);
		}
	}

	const handleCloseFilterModal = () => {
		setShowFilterModal(false)
	}
	const handleOpenFilterModal = () => {
		setShowFilterModal(true)
	}
	const cahngeCategory = (async (event) => {
		setItemCat(event);
		setItemSubCat(0);
		await props.getSubCategoryMap({cat_id: event?.cat_id})
	});
	const changeSubCategory = ((event) => {
		setItemSubCat(event)
	});
	const cahngeBrand = ((event) => {
		setItemBrand(event)
	});
	const changeSupplier = ((event) => {
		setItemSupplierId(event);
	});
	const changeDietary = ((event) => {
		setItemDietary(event || []);
	});

	/**
	 *
	 * @param {type} event handle_apply_filters
	 */
	const applyFilter = (type = "type_filter") => {
		let filter = {};
		let supplier = 0;
		//## if type filter
		if (type == "type_filter") {
			if (itemCat != 0) filter.cat_id = itemCat?.cat_id;
			if (itemSubCat != 0) filter.sub_cat_id = itemSubCat?.sub_cat_id
			if (itemBrand != 0) filter.brand_id = itemBrand?.brand_id;
			if (itemSupplierId != 0) supplier = itemSupplierId?.store_user_id;
			if (itemCountry != 0) filter.country_code = itemCountry?.id;
			if (itemDietary && itemDietary.length > 0) {
				filter.dietary_ids = itemDietary.map(d => d.diet_id);
			}
			filter.new_arrival = itemNewArrival ? 1 : 0;
			filter.promo = itemPromotion ? 1 : 0;
			filter.trending = itemTrending ? 1 : 0;
			filter.status = itemOrderStatus;
			filter.oos = itemOOS;
		}
		setflag(true)
		setFilters(filter)
		setProducts({
			loading: true,
			data: null,
			error: false
		})
		API.getProduct({
			page: page,
			limit: 20,
			filter: filter,
			search: searchString || "",
			supplier: supplier
		})
			.then((response) => response.json())
			.then(response => {
				setShowFilterModal(false)
				setPage(1);
				setTotalPage(response.data.total_page);
				setProducts({
					loading: false,
					data: response.data.list,
					error: false
				})
				setTotalItems(response.data.total_count)
				setProductsUrl(productListUrl);
				if (response.data.list.length == 20) {
					setNext(true)
				} else {
					setNext(false);
				}
			}).catch(() => {
			setProducts({
				loading: false,
				data: null,
				error: true
			})
		});


	}

	/*** Upload Promotion ***/
	const [showUploadPromotion, setShowUploadPromotion] = useState(false);
	const [promotionFile, setPromotionFile] = useState(null);

	const handlePromoToast = () => {
		setShowUploadPromotion(false);
		setToastMessage('Upload Successfully!');
		setToastBgColor('bg-success')

		let timeout = setTimeout(() => {
			setShowToast(true);
		}, 500);
		return () => clearTimeout(timeout);
	}
	const convertDate = (date) => {
		let d = date;

		if (typeof date === "number") {
			// Convert serial number (e.g., Excel date) to a valid date string
			d = new Date(Date.UTC(0, 0, d - 1)).toLocaleDateString();
		}

		// Use moment to format with 12AM time
		d = moment(d).startOf('day').format("YYYY-MM-DD HH:mm:ss");

		return new Date(d);
	};

	const convertToShortDate = (date) => {
		let d = date;

		if (typeof date === "number") {
			d = new Date(Date.UTC(0, 0, d - 1)).toLocaleDateString();
		}

		// Format with time reset to 12AM, then return only the date part
		return moment(d).startOf('day').format("DD-MM-YYYY");
	};
	const handleShowUploadPromotion = () => {
		setShowUploadPromotion(prev => !prev)
		setPromotionFile(null);
	};

	const handleChangePromotionFile = (event) => {
		const files = event.target.files;
		if (files.length) {
			const file = files[0];
			const reader = new FileReader();
			reader.onload = (e) => {
				const wb = read(e.target.result);
				const sheets = wb.SheetNames;
				if (sheets.length) {
					const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
					setPromotionFile(rows);
				}
			};
			reader.readAsArrayBuffer(file);
		}
	};

	const handleSubmitUploadPromotion = (e) => {
		e.preventDefault();
		if (promotionFile) {
			for (let row of promotionFile) {
				if (row.sku) {
					row.sku = row.sku.toString().trim();
				}
				if (row.promo) {
					row.promo = row.promo.toLowerCase() === "yes" ? 1 : 0;
				}
				if (row.enable_promo_cost) {
					row.enable_promo_cost = row.enable_promo_cost.toLowerCase() === "yes" ? 1 : 0;
				}
				if (row.promo_start_date) {
					row.promo_start_date = convertDate(row.promo_start_date);
				}
				if (row.promo_end_date) {
					row.promo_end_date = convertDate(row.promo_end_date);
				}
				if (row.promo_cost_start_date) {
					row.promo_cost_start_date = convertDate(row.promo_cost_start_date);
				}
				if (row.promo_cost_end_date) {
					row.promo_cost_end_date = convertDate(row.promo_cost_end_date);
				}
			}
			props.uploadPromotion(promotionFile, handlePromoToast);
		} else {
			alert("You haven't selected any file yet!");
		}
	}

	const handleDownloadSampleExcel = () => {
		let data = [
			{
				sheet: 'INPUT',
				columns: [
					{label: 'sku', value: 'sku'},
					{label: 'status', value: 'status'},
					{label: 'qty_in_stock', value: 'qty_in_stock'},
					{label: 'price', value: 'price'},
					{label: 'promo', value: 'promo'},
					{label: 'promo_price', value: 'promo_price'},
					{
						label: 'promo_start_date',
						value: 'promo_start_date',
						format: 'd-mmm-yy',
					},
					{
						label: 'promo_end_date',
						value: 'promo_end_date',
						format: 'd-mmm-yy',
					},
					{label: 'enable_promo_cost', value: 'enable_promo_cost'},
					{label: 'promo_cost', value: 'promo_cost'},
					{
						label: 'promo_cost_start_date',
						value: 'promo_cost_start_date',
						format: 'd-mmm-yy',
					},
					{
						label: 'promo_cost_end_date',
						value: 'promo_cost_end_date',
						format: 'd-mmm-yy',
					},
				],
				content: [
					{
						sku: "JAVA008",
						status: 'enabled',
						qty_in_stock: 50,
						price: 5,
						promo: 'yes',
						promo_price: 8,
						promo_start_date: '01-Jan-23',
						promo_end_date: '31-Dec-23',
						enable_promo_cost: 'yes',
						promo_cost: 4,
						promo_cost_start_date: '01-Jan-23',
						promo_cost_end_date: '31-Dec-23',
					},
				],
			},
		];

		let settings = {
			fileName: 'PROMOTION_TEMPLATE',
			extraLength: 3,
			writeMode: 'writeFile',
			writeOptions: {},
			RTL: false, // Display the columns from right-to-left (the default value is false)
		};

		xlsx(data, settings);
	};

	let contentSupplier = null;
	let contentBrands = null;
	let contentCategory = null;
	let contentSubCategory = null;
	if (props.brands) {
		contentBrands = props.brands.map((brand, key) =>
			<option key={key} value={brand.brand_id}>{brand.name}</option>
		)
	}
	if (props.category) {
		contentCategory = props.category.map((cat, key) =>
			<option key={key} value={cat.cat_id}>{cat.list_categories[0].name}</option>
		)
	}
	if (props.sub_category) {
		contentSubCategory = props.sub_category.map((subCat, key) =>
			<option key={key} value={subCat.sub_cat_id}>{subCat.list_sub_categories[0].name}</option>
		)
	}
	if (props.suppliers) {
		contentSupplier = props.suppliers.map((supplier, key) =>
			<option key={key} value={supplier.store_user_id}>{supplier.store_users[0].first_name}</option>
		)
	}

	useEffect(() => {
		if (!showEnable && !enableButtonRef.current) return;
		enableButtonRef.current.focus();
	}, [enableButtonRef, showEnable]);

	useEffect(() => {
		if (!showDisable && !disableButtonRef.current) return;
		disableButtonRef.current.focus();
	}, [disableButtonRef, showDisable]);

	useEffect(() => {
		if (!showInStock && !quantityInputRef.current) return;
		quantityInputRef.current.focus();
	}, [quantityInputRef, showInStock]);

	useEffect(() => {
		if (!showOutOfStock && !markOutOfStockButtonRef.current) return;
		markOutOfStockButtonRef.current.focus();
	}, [markOutOfStockButtonRef, showOutOfStock]);


	return (
		<HelpPageWrapper>
			<Row>
				<Col lg={3}>
					{isError ? <Alert variant="danger">{errorText}</Alert> : ""}
					<InputGroup className="mb-3">
						<FormControl
							placeholder="Product name"
							aria-label="Product name"
							aria-describedby="basic-addon2"
							value={searchString}
							onChange={changeSearchString}
							onKeyDown={handleKeyDown}
						/>
						<InputGroup.Append>
							{isSubmitted ? (
								<Spinner animation="grow" variant="success"/>
							) : (
								<Button
									variant="outline-secondary"
									onClick={() => searchInitiate(productSearchUrl, 1)}
								>
									Search
								</Button>
							)}
						</InputGroup.Append>
					</InputGroup>
				</Col>
				<Col lg={2}>
					<Button
						className="pull-right px-4"
						variant="success"
						type="submit"
						onClick={handleOpenFilterModal}
					>
						Filters
					</Button>
				</Col>
				<Col lg={2} className="my-2 my-lg-0">
					<Button variant="success" onClick={handleShowUploadPromotion}>
						Upload Promotion
					</Button>
				</Col>
				<Col lg={2}>
					<Button variant="success" type="submit" onClick={addProductPage}>
						Add product
					</Button>
				</Col>
				<Col lg={3}>
					<Button
						className="pull-right"
						variant="danger"
						type="submit"
						onClick={handleShowDeleteProductModal}
					>
						Show Deleted Products
					</Button>
				</Col>
			</Row>
			<Row>
				<Col lg={12}>
					<ButtonGroup toggle className="pull-right">
						<ToggleButton
							type="radio"
							variant="primary"
							name="radio"
							onClick={getProductsListFirst}
						>
							First
						</ToggleButton>
						<ToggleButton
							type="radio"
							variant="primary"
							name="radio"
							onClick={getProductsListPrevious}
						>
							<ArrowBackIosIcon style={{fontSize: "18px"}}/>
						</ToggleButton>
						<ToggleButton
							type="radio"
							variant="outline-dark"
							disabled
							name="radio"
						>
							{page}/{totalPage}
						</ToggleButton>
						<ToggleButton
							type="radio"
							variant="primary"
							name="radio"
							onClick={getProductsListNext}
						>
							<NavigateNextIcon style={{fontSize: "25px"}}/>
						</ToggleButton>
						<ToggleButton
							type="radio"
							variant="primary"
							name="radio"
							onClick={getProductsListLast}
						>
							Last
						</ToggleButton>
					</ButtonGroup>
				</Col>
			</Row>
			<Row className="mt-1">
				<Col sm={12}>
					<TableBodyWidth
						className="table-responsive"
						style={{height: "calc(100vh - 280px)"}}
					>
						<Table striped bordered hover>
							<thead>
							<tr>
								<th>Image</th>
								<th
									onClick={() => handleSortOrder("item_id")}
									className="sort-style"
								>
									ID
									{orderField === "item_id"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("product_code")}
									className="sort-style"
								>
									SKU
									{orderField === "product_code"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("name")}
									className="sort-style"
								>
									Product Name
									{orderField === "name"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("brand")}
									className="sort-style"
								>
									Brand
									{orderField === "brand"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("qty")}
									className="sort-style"
								>
									QTY
									{orderField === "qty"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("variant")}
									className="sort-style"
								>
									Variant
									{orderField === "variant"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("supplier")}
									className="sort-style"
								>
									Supplier
									{orderField === "supplier"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("category")}
									className="sort-style"
								>
									Category
									{orderField === "category"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("subcategory")}
									className="sort-style"
								>
									SubCategory
									{orderField === "subcategory"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("country")}
									className="sort-style"
								>
									Country
									{orderField === "country"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th>Dietary</th>
								<th
									onClick={() => handleSortOrder("cost")}
									className="sort-style"
								>
									Cost
									{orderField === "cost"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("price")}
									className="sort-style"
								>
									Price
									{orderField === "price"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("promo_cost")}
									className="sort-style"
								>
									Promo Cost
									{orderField === "promo_cost"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th
									onClick={() => handleSortOrder("promo_price")}
									className="sort-style"
								>
									Promo Price
									{orderField === "promo_price"
										? orderType === "DESC"
											? DownArrow
											: UpArrow
										: UpDownArrow}
								</th>
								<th>Promo Date</th>
								<th>Position</th>
								{/* <th>Tranding</th> */}
								<th>Status</th>
								{/* <th>Quantity</th> */}
								<th>Actions</th>
							</tr>
							</thead>
							<tbody>
							{content}
							{message}
							</tbody>
						</Table>
					</TableBodyWidth>
					<div className="mt-2" style={{width: "100%", textAlign: "right"}}>
						<span style={{fontWeight: "bold"}}>Total: </span>
						{totalItems}
					</div>
				</Col>
			</Row>

			<Modal show={showEnable} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>{modalHead}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{modalMessage}</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
					<Button
						variant="success"
						ref={enableButtonRef}
						autoFocus={true}
						onClick={enableProduct}
					>
						Enable
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal show={showDisable} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>{modalHead}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{modalMessage}</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
					<Button
						variant="danger"
						ref={disableButtonRef}
						autoFocus={true}
						onClick={enableProduct}
					>
						Disable
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal show={showInStock} onHide={handleCloseQuantityModal}>
				<Modal.Header closeButton>
					<Modal.Title>{modalHeadQuantityModal}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{modalMessageQuantityModal}</Modal.Body>
				<Modal.Footer>
					<Form className="w-100" onSubmit={inStockProduct}>
						<Alert show={quantityError} variant="danger" severity="error">
							Please enter valid quantity!
						</Alert>
						<InputGroup size="sm" className="mb-3">
							<InputGroup.Prepend>
								<InputGroup.Text id="inputGroup-sizing-sm">
									Enter Quantity
								</InputGroup.Text>
							</InputGroup.Prepend>
							<FormControl
								aria-label="Small"
								ref={quantityInputRef}
								autoFocus={true}
								id="quantity-ref"
								aria-describedby="inputGroup-sizing-sm"
								value={quantity}
								onChange={handleSetQuantity}
							/>
						</InputGroup>
						<div
							style={{
								display: "flex",
								justifyContent: "end",
								flexWrap: "wrap",
								gap: 8,
							}}
						>
							<Button variant="secondary" onClick={handleCloseQuantityModal}>
								Close
							</Button>
							<Button variant="success" type="submit">
								In Stock
							</Button>
						</div>
					</Form>
				</Modal.Footer>
			</Modal>

			<Modal show={showOutOfStock} onHide={handleCloseQuantityModal}>
				<Modal.Header closeButton>
					<Modal.Title>{modalHeadQuantityModal}</Modal.Title>
				</Modal.Header>
				<Modal.Body>{modalMessageQuantityModal}</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseQuantityModal}>
						Close
					</Button>
					<Button
						variant="danger"
						ref={markOutOfStockButtonRef}
						autoFocus={true}
						onClick={inStockProduct}
					>
						Mark out of stock
					</Button>
				</Modal.Footer>
			</Modal>
			<Modal show={showImage} onHide={hnadleShowImageClose}>
				<Modal.Header closeButton>
					<Modal.Title>Image</Modal.Title>
				</Modal.Header>
				<Modal.Body
					style={{
						height: "400Px",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<img
						alt="Product"
						src={imgUrl === null || imgUrl === undefined ? PIcon : imgUrl}
						style={{width: "400Px", height: "400px", objectFit: "contain"}}
						onError={(e) => {
							e.target.onerror = null;
							e.target.src = PIcon;
						}}
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={hnadleShowImageClose}>
						Close
					</Button>
					{/* <Button variant="danger">
                 Mark out of stock            
            </Button> */}
				</Modal.Footer>
			</Modal>

			{/* filter modal */}
			<Modal size="lg" show={showFilterModel} onHide={handleCloseFilterModal}>
				<Modal.Header closeButton>
					<Modal.Title><FaFilter style={{fontSize: "30px"}}/> Filters</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Row>
							<Form.Group as={Col} controlId="formGridState">
								<Form.Label className="font-weight-bold">Category</Form.Label>
								<SelectAndSearchComponent
									options={props.category}
									value={itemCat}
									onChange={cahngeCategory}
									placeholder="Select Category"
									getOptionValue={(opt) => opt.list_categories[0].name}
									getOptionLabel={(cat) => (
										<div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
											<img src={cat?.list_categories[0].image}
											     style={{width: "20px", objectFit: "contain"}}/> {cat.list_categories[0].name}
										</div>
									)}
								/>
							</Form.Group>
						</Form.Row>

						<Form.Row>
							<Form.Group as={Col} controlId="formGridState">
								<Form.Label className="font-weight-bold">Sub Category</Form.Label>
								<SelectAndSearchComponent
									options={props.sub_category}
									value={itemSubCat}
									onChange={changeSubCategory}
									placeholder="Select SubCategory"
									getOptionValue={(opt) => opt.list_sub_categories[0].name}
									getOptionLabel={(subcat) => (
										<div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
											<img src={subcat?.list_sub_categories[0].image}
											     style={{width: "20px", objectFit: "contain"}}/> {subcat.list_sub_categories[0].name}
										</div>
									)}
								/>
							</Form.Group>
						</Form.Row>

						<Form.Row>
							<Form.Group as={Col} controlId="formGridState">
								<Form.Label className="font-weight-bold">Brand</Form.Label>
								<SelectAndSearchComponent
									options={props.brands}
									value={itemBrand}
									onChange={cahngeBrand}
									placeholder="Select Brand"
								/>
							</Form.Group>
						</Form.Row>

						<Form.Row>
							<Form.Group as={Col} controlId="formGridState">
								<Form.Label className="font-weight-bold">Supplier</Form.Label>
								<SelectAndSearchComponent
									options={props.suppliers}
									value={itemSupplierId}
									onChange={changeSupplier}
									placeholder="Select Supplier"
									getOptionValue={(opt) => opt.store_users[0].first_name}
									getOptionLabel={(supplier) => (
										<div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
											{supplier.store_users[0].first_name}
										</div>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Group as={Col} controlId="formGridState">
								<Form.Label className="font-weight-bold">Country</Form.Label>
								<Select
									placeholder="Select Country"
									value={itemCountry}
									onChange={changeCountry}
									options={countriesOptions}
									isClearable
									isSearchable
									getOptionValue={(opt) => opt.name}
									getOptionLabel={(country) => (
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "5px",
											}}
										>
                      <span style={{height: "fit-content"}}>
                        <FlagIcon code={country.code.toLowerCase()}/>
                      </span>
											{country.name}
										</div>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Group as={Col} controlId="formGridState">
								<Form.Label className="font-weight-bold">Dietary Preferences</Form.Label>
								<Select
									placeholder="Select Dietary Preferences"
									value={itemDietary}
									onChange={changeDietary}
									options={dietaryPreferences}
									isClearable
									isSearchable
									isMulti
									getOptionValue={(opt) => opt.diet_id}
									getOptionLabel={(dietary) => (
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "5px",
											}}
										>
											{dietary.image_url && (
												<img
													src={dietary.image_url}
													alt={dietary.name}
													style={{width: "20px", height: "20px", objectFit: "contain"}}
												/>
											)}
											{dietary.name}
										</div>
									)}
								/>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Group>
								<Form.Label className="font-weight-bold">Status</Form.Label>
								<RadioGroup
									row
									component="fieldset"
									className="d-flex"
									aria-label="status"
									name="status"
									value={itemOrderStatus}
									onChange={handleStatusChange}
								>
									<FormControlLabel
										value="all"
										control={<Radio color="primary"/>}
										label="All"
									/>
									<FormControlLabel
										value="active"
										control={<Radio color="primary"/>}
										label="Active"
									/>
									<FormControlLabel
										value="in_active"
										control={<Radio color="primary"/>}
										label="InActive"
									/>
								</RadioGroup>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Group>
								<Form.Label className="font-weight-bold">Out Of Stock</Form.Label>
								<RadioGroup
									row
									component="fieldset"
									className="d-flex"
									aria-label="oos"
									name="oos"
									value={itemOOS}
									onChange={handleOOSChange}
								>
									<FormControlLabel
										value="all"
										control={<Radio color="primary"/>}
										label="All"
									/>
									<FormControlLabel
										value="in_stock"
										control={<Radio color="primary"/>}
										label="In Stock"
									/>
									<FormControlLabel
										value="out_of_stock"
										control={<Radio color="primary"/>}
										label="Out of Stock"
									/>
								</RadioGroup>
							</Form.Group>
						</Form.Row>
						<Form.Row>
							<Form.Label className="font-weight-bold">Promotion Type</Form.Label>
						</Form.Row>
						<FormControlLabel
							control={
								<Checkbox
									checked={itemNewArrival}
									onChange={handleItemNewArrivalChange}
									name="check_new_arrival"
									color="primary"
								/>
							}
							label="New Arrival"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={itemPromotion}
									onChange={handleItemPromotionChange}
									name="check_promotion"
									color="primary"
								/>
							}
							label="Promotion"
						/>

						{/* <Form.Row>
              <Form.Group as={Col} controlId="formGridState">
                <Form.Label>Brand</Form.Label>
                <Form.Check
                  type="checkbox"
                  label="Trending"
                  checked={itemTrending}
                  onChange={handleItemTrendingChange}
                />
              </Form.Group>
            </Form.Row> */}
					</Form>
				</Modal.Body>
				<Modal.Footer className="d-flex justify-content-between">
					<Button variant="secondary" onClick={handleCloseFilterModal}>
						Close
					</Button>
					<div>
						<Button
							className="mr-1"
							variant="danger"
							onClick={handleClearFilter}
						>
							<CgPlayListRemove style={{fontSize: "25px"}}/> Clear Filters
						</Button>
						<Button variant="primary" onClick={() => applyFilter('type_filter')}>
							<FaFilter/> Apply Filters
						</Button>
					</div>
				</Modal.Footer>
			</Modal>

			<Modal
				show={dialogDelete}
				onHide={handleDialogDelete}
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Delete product</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Are you sure want to delete <strong>{deleteItemName}</strong>?
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => handleDialogDelete(false)}>
						Close
					</Button>
					<Button variant="danger" onClick={() => softDeleteProduct()}>
						Delete
					</Button>
				</Modal.Footer>
			</Modal>

			<Modal
				show={showUploadPromotion}
				onHide={handleShowUploadPromotion}
				aria-labelledby="contained-modal-title-vcenter"
				size="xl"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Upload Promotion</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Row>
							<Form.Group>
								<Form.Control
									type="file"
									accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
									onChange={handleChangePromotionFile}
								/>
							</Form.Group>
							<Button
								variant="primary"
								type="submit"
								className="ml-auto"
								onClick={handleSubmitUploadPromotion}
							>
								Upload
							</Button>
							<Button
								variant="info"
								type="submit"
								className="ml-sm-5"
								onClick={handleDownloadSampleExcel}
							>
								Download Sample
							</Button>
						</Form.Row>
					</Form>
					<Row className="mt-2 mb-1">
						<Col>
							<div className="lead d-flex align-items-center">
								<p>Preview &nbsp;</p> {promotionFile && promotionFile.length > 0 &&
								<Typography variant={"subtitle1"} color={"error"}> ({promotionFile.length} Products)</Typography>}
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<TableBodyWidth
								className="table-responsive"
								style={{height: "calc(100vh - 250px)"}}
							>
								<Table striped bordered hover>
									<thead>
									<tr>
										<th>Sku</th>
										<th>Status</th>
										<th>Qty in Stock</th>
										<th>Price</th>
										<th>Promo</th>
										<th>Promotion Price</th>
										<th>Promotion Price Date</th>
										<th>Enable Promo Cost</th>
										<th>Promotion Cost</th>
										<th>Promotion Cost Date</th>
									</tr>
									</thead>
									<tbody>
									{promotionFile !== null ? (
										promotionFile.map((promo, index) => (
											<tr key={index}>
												<td>{promo.sku}</td>
												<td>{promo.status ? promo.status : "-"}</td>
												<td>
													{promo.qty_in_stock ? promo.qty_in_stock : "-"}
												</td>
												<td>
													{promo.price ? (
														<FormattedNumber
															value={promo.price}
															style="currency"
															currency="USD"
														/>
													) : (
														"-"
													)}
												</td>
												<td>{promo.promo ? promo.promo : "-"}</td>
												<td>
													{promo.promo_price ? (
														<FormattedNumber
															value={promo?.promo_price}
															style="currency"
															currency="USD"
														/>
													) : (
														"-"
													)}
												</td>
												<td>
													{(promo.promo_start_date
															? convertToShortDate(promo.promo_start_date)
															: "-") +
														" / " +
														(promo.promo_end_date
															? convertToShortDate(promo.promo_end_date)
															: "-")}
												</td>
												<td>
													{promo.enable_promo_cost
														? promo.enable_promo_cost
														: "-"}
												</td>
												<td>
													{promo.promo_cost ? (
														<FormattedNumber
															value={promo.promo_cost}
															style="currency"
															currency="USD"
														/>
													) : (
														"-"
													)}
												</td>
												<td>
													{(promo.promo_cost_start_date
															? convertToShortDate(promo.promo_cost_start_date)
															: "-") +
														" / " +
														(promo.promo_cost_end_date
															? convertToShortDate(promo.promo_cost_end_date)
															: "-")}
												</td>
											</tr>
										))
									) : (
										<tr>
											<td colSpan="10" className="text-center">
												No Records
											</td>
										</tr>
									)}
									</tbody>
								</Table>
							</TableBodyWidth>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>

			{/* show modal is delete */}
			<Modal
				show={showDeletedProductModal}
				onHide={handleCloseDeleteProductModal}
				aria-labelledby="contained-modal-title-vcenter"
				size="xl"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Products Deleted</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col lg={4}>
							<InputGroup className="mb-3">
								<FormControl
									placeholder="Product name"
									aria-label="Product name"
									aria-describedby="basic-addon2"
									value={searchStr}
									onChange={searchDStr}
									// onKeyDown={handleKeyDown}
								/>
								<InputGroup.Append>
									<Button
										variant="outline-primary"
										onClick={() => {
											searchDeletedInitiate(1);
										}}
									>
										Search
									</Button>
								</InputGroup.Append>
							</InputGroup>
						</Col>
					</Row>
					<Row>
						<Col>
							<TableBodyWidth
								className="table-responsive"
								style={{height: "calc(100vh - 250px)"}}
							>
								<Table striped bordered hover>
									<thead>
									<tr>
										<th>Image</th>
										<th>ID</th>
										<th>Sku</th>
										<th>Name</th>
										<th>Price</th>
										<th>Action</th>
									</tr>
									</thead>
									<tbody>
									{getIsDeletedProduct.data.length > 0 ? (
										getIsDeletedProduct.data.map((product, index) => (
											<tr key={index}>
												<td
													onClick={() =>
														hnadleShowImageOpen(product.default_image_url)
													}
													style={logoWrapper}
												>
													<img
														src={
															!product.default_image_url
																? PIcon
																: product.default_image_url
														}
														alt="img"
														style={logo}
														onError={(e) => {
															e.target.onerror = null;
															e.target.src = PIcon;
														}}
													/>
												</td>
												<td>{product ? product.item_id : ""}</td>
												<td>{product ? product.product_code : ""}</td>
												<td>{product ? product.name : ""}</td>
												<td>
													{product.store_items_price_types[0] ? (
														<FormattedNumber
															value={product.store_items_price_types[0].price}
															style="currency"
															currency="USD"
														/>
													) : (
														""
													)}
												</td>
												<td className="text-center">
													<Button
														className="ml-1"
														variant="warning"
														onClick={() => showReversedModal(product)}
													>
														<RestoreIcon/>
													</Button>
												</td>
											</tr>
										))
									) : getIsDeletedProduct.loading === true ? (
										<tr>
											<td colSpan="10" className="text-center">
												<Spinner
													variant="success"
													animation="border"
													size="lg"
												/>
											</td>
										</tr>
									) : (
										<tr>
											<td colSpan="10" className="text-center">
												No Records
											</td>
										</tr>
									)}
									</tbody>
								</Table>
							</TableBodyWidth>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Row>
						<Col lg={12} className="pull-right p-2">
							<ButtonGroup toggle className="pull-right">
								<ToggleButton
									type="radio"
									variant="primary"
									name="radio"
									onClick={getDeletedProductsListPrevious}
								>
									Back
								</ToggleButton>
								<ToggleButton type="radio" variant="primary" name="radio">
									{dPage}/{tPage}
								</ToggleButton>
								<ToggleButton
									type="radio"
									variant="primary"
									name="radio"
									onClick={getDeletedProductsListNext}
								>
									Next
								</ToggleButton>
							</ButtonGroup>
						</Col>
					</Row>
				</Modal.Footer>
			</Modal>

			<Modal
				show={confirmReverseModal}
				onHide={showReversedModal}
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Reversed product</Modal.Title>
				</Modal.Header>
				<Modal.Body>Are you sure want to Reverse Product?</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={showReversedModal}>
						No
					</Button>
					<Button variant="warning" onClick={handleConfirmReverse}>
						Ok
					</Button>
				</Modal.Footer>
			</Modal>

			<Toast
				className={toastBgColor}
				onClose={() => setShowToast(false)}
				show={showToast}
				delay={3000}
				autohide
				style={{
					position: "fixed",
					top: 70,
					right: 35,
					zIndex: 1041,
				}}
			>
				<Toast.Header>
					<strong className="mr-auto">{toastMessage}</strong>
				</Toast.Header>
			</Toast>
		</HelpPageWrapper>
	);
}

const mapStateToProps = state => {
	return {
		products: state.dashboardReducer.products,
		brands: state.dashboardReducer.brands,
		category: state.dashboardReducer.category,
		sub_category: state.dashboardReducer.sub_category,
		suppliers: state.dashboardReducer.suppliers,
		countries: state.dashboardReducer.countries,
	}

}

const mapDispatchToProps = dispatch => {
	return {
		getProduct: data => getProduct(data, dispatch),
		searchProduct: data => searchProduct(data, dispatch),
		getBrands: data => getBrands(data, dispatch),
		getCategory: data => getCategory(data, dispatch),
		getSubCategory: data => getSubCategory(data, dispatch),
		getSuppliers: data => getSuppliers(data, dispatch),
		getSubCategoryMap: data => getSubCategoryMap(data, dispatch),
		uploadPromotion: (data, handleToast) => uploadPromotion(data, handleToast, dispatch),
		getCountries: data => getCountries(data, dispatch),
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductListing)
